import { render } from "./GamesSectionNavbar.vue?vue&type=template&id=e744433c&scoped=true"
import script from "./GamesSectionNavbar.vue?vue&type=script&lang=js"
export * from "./GamesSectionNavbar.vue?vue&type=script&lang=js"

import "./GamesSectionNavbar.vue?vue&type=style&index=0&id=e744433c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e744433c"]])

export default __exports__